<template>
  <router-view v-slot="{ Component }">
    <transition name="slide-fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script>

// import HomeView from './HomeView.vue';

export default {
}
</script>

<style>
.slide-fade-enter-active {
  transition: all .25s ease-out;
}

.slide-fade-leave-active {
  transition: all .15s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from{
  transform: translateX(-25px);
}
.slide-fade-leave-to {
  transform: translateX(10px);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
}
</style>